import React, { useEffect, useState } from 'react';
import { fetchProductMenu } from '@/services';
import { FileTextOutlined } from '@ant-design/icons'
import type { MenuItem } from '@/types/typing';
import * as Icons from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import Settings from '../../config/defaultSettings';


const DynamicSubMenu: React.FC = () => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

  const { initialState, setInitialState } = useModel('@@initialState');
  const { currentUser } = initialState;

  const allRoles = currentUser?.teamList?.reduce((acc: string[], team) => {
    if (Array.isArray(team.roles)) {
      return acc.concat(team.roles);
    }
    return acc;
  }, []);

  // 去重，确保角色数组中没有重复的角色
  const uniqueALlRoles = Array.from(new Set(allRoles));

  useEffect(() => {
    // 动态子菜单
    // const getMenuData = async () => {
    //   const {data} = await fetchProductMenu();
    //   setMenuItems(data);
    // };
    // getMenuData();
    // 暂时设置为固定子菜单
    // 仅当 uniqueALlRoles 包含 'system' 时显示 "系统管理"
    const data = [
      { path: "/documents", name: "帮助文档", icon: "FileTextOutlined" },
      ...(uniqueALlRoles?.some((role) => ['system', 'admin', 'tenant_admin'].includes(role))
        ? [{ path: "/admin/tenantview", name: "系统管理", icon: "SettingOutlined" }]
        : []
      )
    ];

    setMenuItems(data)
  }, []);

  // 动态渲染图标
  const renderIcon = (iconName: string) => {
    const IconComponent = (Icons as any)[iconName]; // 动态获取图标组件
    return IconComponent ? <IconComponent /> : null; // 如果图标存在，则渲染，否则返回 null
  };

  const handleLinkTo = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault(); 
    const fullPath = `${window.location.origin}${Settings.base}#${path}`; 
    window.open(fullPath, '_blank');
  }

//   const handleLinkTo = (path: string) => (e: React.MouseEvent) => {
//   e.preventDefault();
//   if (history) {
//     history.push(path); // 使用 Umi 的 history.push 方法
//   } else {
//     window.location.hash = path; // 设置 Hash 路由
//   }
// };

  return (
    <div className="dynamic-sub-menu">
      {menuItems?.map((item) => (
        <a key={item.path} href={item.path} target="_blank" className="custom-link" onClick={handleLinkTo(item.path)}>
          {renderIcon(item.icon)} {/* 动态渲染图标 */}
          <span rel="noopener noreferrer" className='customLink-title'>{item.name}</span>
        </a>
      ))}
    </div>
  );
};

export default DynamicSubMenu;